import axios from 'axios';
import { setAlert } from './alert';
import {
  GET_NOTIFICATION,
  GET_NOTIFICATIONS,
  NOTIFICATION_ERROR,
  DELETE_NOTIFICATION,
  ADD_NOTIFICATION,
  UPDATE_NOTIFICATION
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// Get all Notifications
export const getNotifications = () => async dispatch => {
  try {
    const res = await axios.get(`${API_URL}/notifications/all`);
    dispatch({
      type: GET_NOTIFICATIONS,
      payload: res.data.data.notifications
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Get Notification by ID
export const getNotificationById = id => async dispatch => {
  try {
    const res = await axios.get(`${API_URL}/notifications/${id}`);

    dispatch({
      type: GET_NOTIFICATION,
      payload: res.data.data.notification
    });
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};

// Create Notification
export const createNotification = (formData, navigate) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.post(`${API_URL}/notifications`, formData, config);

    dispatch({
      type: ADD_NOTIFICATION,
      payload: res.data.data
    });

    dispatch(setAlert('Notification Created', 'success'));    
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    
    return null;
  }
};

// Update Notification
export const updateNotification = (id, formData) => async dispatch => {
  try {
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const res = await axios.put(`${API_URL}/notifications/${id}`, formData, config);

    dispatch({
      type: UPDATE_NOTIFICATION,
      payload: res.data.data.notification
    });

    dispatch(setAlert('Notification Updated', 'success'));
    return true;
  } catch (err) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
    }

    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
    return false;
  }
};

// Delete Notification
export const deleteNotification = id => async dispatch => {
  try {
    await axios.delete(`${API_URL}/notifications/${id}`);

    dispatch({
      type: DELETE_NOTIFICATION,
      payload: id
    });

    dispatch(setAlert('Notification Removed', 'success'));
  } catch (err) {
    dispatch({
      type: NOTIFICATION_ERROR,
      payload: { msg: err.response.statusText, status: err.response.status }
    });
  }
};
